import { Select } from 'antd';
import React from 'react';
import { translations } from '../../../config/translations';
import { TransferEmployeeVm, TransferWarehouseVm } from '../../../utils/api';
import { locationKey } from '../helpers';

export interface LocationSelectProps {
    warehouses: TransferWarehouseVm[];
    /** Leave empty to offer warehouses only. */
    employees?: TransferEmployeeVm[];
    /** A location key ("w:12" / "e:5"); see locationKey. */
    value?: string;
    onChange?: (key?: string) => void;
    /** A key not to offer, e.g. the source when picking the destination. */
    excludeKey?: string;
    allowClear?: boolean;
    disabled?: boolean;
    placeholder?: string;
    style?: React.CSSProperties;
}

/** One dropdown for a transfer end or tool location: warehouses and people in separate groups. */
const LocationSelect: React.FC<LocationSelectProps> = ({
    warehouses,
    employees = [],
    value,
    onChange,
    excludeKey,
    allowClear,
    disabled,
    placeholder,
    style,
}) => {
    const options = (
        items: { id: number; name: string }[],
        key: (id: number) => string | undefined
    ) =>
        items
            .filter((item) => key(item.id) !== excludeKey)
            .map((item) => (
                <Select.Option key={key(item.id)} value={key(item.id) as string}>
                    {item.name}
                </Select.Option>
            ));

    return (
        <Select
            showSearch
            optionFilterProp="children"
            value={value}
            onChange={(key?: string) => onChange && onChange(key)}
            allowClear={allowClear}
            disabled={disabled}
            placeholder={placeholder}
            style={style}
        >
            <Select.OptGroup label={translations.transfers.warehouses}>
                {options(warehouses, (id) => locationKey(id))}
            </Select.OptGroup>
            {employees.length > 0 && (
                <Select.OptGroup label={translations.transfers.people}>
                    {options(employees, (id) => locationKey(undefined, id))}
                </Select.OptGroup>
            )}
        </Select>
    );
};

export default LocationSelect;
